<template>
    <div class='convention-catalogue clause'>
        <div v-for='(abstraction, aindex) in convention' :key='`c-abstraction-${aindex}`' class='clause-section'>
            <h3>{{abstraction.title}}</h3>
            <p v-html='abstraction.intro'></p>
            <div class='convention-subjects' v-if='abstraction.subjects'>
                <div v-for='(subject, sindex) in abstraction.subjects' :key='`c-subject-${sindex}`'>
                    <h4>
                        {{aindex + 1}}.{{sindex + 1}}
                        {{subject.name}}
                    </h4>
                    <p v-html='subject.context'/>
                    <div v-if='subject.details' class='convention-subject__detail'>
                        <div v-for='(detail, dindex) in subject.details' :key='`c-subject-${dindex}`'>
                            <h4 class='text text-separate'>
                                {{aindex + 1}}.{{sindex + 1}}.{{dindex + 1}}
                                {{detail.subtitle}}
                            </h4>
                            <p v-html='detail.context'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['convention']
    }
</script>

<style lang="less" scoped>
    .convention-subject__detail {
        padding-left: 15px;
    }
</style>


